import * as React from "react";

import * as Yup from "yup";
import FormikForm from "~/lib/forms/FormikForm";
import {Field, Form} from "formik";
import Input from "~/common/controls/Input";
import {emailRegExp} from "~/apps/shared/consts";


export const ValidationSchema = () => {
  return Yup.object().shape({
    email: Yup.array()
      .ensure()
      .compact()
      .typeError("Required")
      .required("Required")
      .test("match", "Not a valid email address, please fix possible typos or enter a valid email", function (value) {
        return emailRegExp.test(value);
      }),
  });
};

export default function SendToForm(props) {
  const {
    defaultValues,
    placeholder,
    onSubmit,
    onBack,
  } = props;

  const sendButton = (isValid) => {
    const title = isValid ? "Send Email" : "Enter a Valid Email";

    return (
      <button className={`btn ${isValid ? "btn--prim" : "btn--lgry"} btn--lg`} type="submit">
        {title}
      </button>
    );
  }
  return (
    <FormikForm
      confirmOnLeave
      initialValues={defaultValues}
      onSubmit={onSubmit}
      validationSchema={ValidationSchema()}
      render={(props) => {
        const {isValid} = props;

        return (
          <Form className="form__cont" style={{marginBottom: "2rem"}}>
            <Field
              validateOnChange
              name="email"
              label="Email address"
              placeholder={placeholder}
              component={Input}
              className="input input--step input--bubble input--bubble--tags"
            />
            {onBack ? (
              <div className="m__foot__btns__dbl">
                {sendButton(isValid)}
                <button className="btn btn--warn btn--lg" onClick={onBack}>
                  Cancel send
                </button>
              </div>
            ) : (
              sendButton(isValid)
            )}
          </Form>
        );
      }}
    />
  );
}
